__turbopack_context__.v({
  "tool-tip-inner-container": "mochi-tooptip-module-scss-module__kOJExq__tool-tip-inner-container",
  "tool-tip-title": "mochi-tooptip-module-scss-module__kOJExq__tool-tip-title",
  "tool-tip-triangle-icon": "mochi-tooptip-module-scss-module__kOJExq__tool-tip-triangle-icon",
});
